import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "../src/containers/App";
require("typeface-roboto");
require("typeface-crimson-text");
require("typeface-montserrat");
require("typeface-nunito");
require("typeface-open-sans");
require("typeface-oxygen");
require("typeface-poppins");
require("typeface-source-sans-pro");
require("typeface-ubuntu");
require("typeface-varela-round");
require("typeface-lato");

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
